/**
 * 开放域关卡好友排行榜
 */
var FriendRankMergeList = xClass("FriendRankMergeList", BasePanel, function () {
    return cc.Node.create();
})
/**
 * @param config    排行榜设置，包括关卡ID，排行榜类型
 */
FriendRankMergeList.prototype.ctor = function (config) {
    var self = this
    config = config || table()
    config.rankType = config.rankType || LevelRankType.kFriend
    self.config = clone(config)
    self.dataLoaded = false
    self.nodeExist = true
    self.itemdatas = table()
    self.items = table()
    self.init()
}

/**
 * 初始化
 */
FriendRankMergeList.prototype.init = function () {
    var self = this

    self.clippingNode = cc.ClippingRectangleNode.create()
    self.innerBgSize = cc.size(686, 170)
    self.clippingNode.setClippingRegion(cc.rect(0, 0, self.innerBgSize.width, self.innerBgSize.height))
    self.clippingNode.setPosition(cc.p(17, -290))
    self.addChild(self.clippingNode)

    //  获取游戏好友数据
    self.itemLength = 0

    //  初始化开放域
    self.initWithOpenDate()
}

/**
 * 开放域UI资源下载状态
 */
FriendRankMergeList.resource = [
    "friendboard_head",
    // "friendrank_friendboard_circle",
    // "friendrank_head_frame_crown",
    // "friendrank_head_frame_tx01",
    // "friendrank_none_friend_img",
    // "friendrank_head_frame_cover",
    // "friendrank_rank_no1",
    // "friendrank_rank_no2",
    // "friendrank_rank_no3",
    // "friendrank_rank_nobg",
    // "friendrank_head_frame_cover_new",
    //
    "start_rank_1",
    "start_rank_2",
    "start_rank_3",
    "start_rank_4",
    "start_rank_bg1",
    "start_rank_player3_blue",
]
/**
 * 初始化开放域
 */
FriendRankMergeList.prototype.initWithOpenDate = function () {
    var self = this
    if (self.config.dataLoaded) {
        return 
    }

    let sharedCanvas = mini.getOpenDataContext().canvas
    sharedCanvas.width = self.innerBgSize.width
    sharedCanvas.height = self.innerBgSize.height
    
    //  加载需要用到的UI
    for (var i = 0; i < FriendRankMergeList.resource.length; i++) {
        let key = FriendRankMergeList.resource[i]
            let param = {
                url: 'https://statich5clover.happyelements.com/resource/upload/' + key + '.png',
                success: res => {
                    OpenContextUtil.postMessage({
                        command: "update img",
                        name: key,
                        path: res.tempFilePath
                    })
                },
                fail:err=> {
                },
            }
            if (mini.useStrictImgMode()) {
                param.extractmap = {
                    picurl: param.url,
                    node: 'FriendRankMergeList.initWithOpenDate'
                }
            }
            mini.downloadFile(param)
       // }
    }

    //  获取好友排行信息后，向开放域发送数据
    self.refresh()
    self.setTouch()

    self.refreshTimer = self.getScheduler().scheduleScriptFunc(function () {
        self.refreshCanvas()
    }, 0, false)
}

FriendRankMergeList.prototype.setTouch = function () {
    var self = this

    let innerSize = self.innerBgSize
    if (window.mini && mini.supportOpenContext()) {
        // 计算触摸事件坐标返回，转换为屏幕坐标（左上角为原点，单位为像素）
        let innerBgPos = self.clippingNode.convertToWorldSpace()
        let wSize = cc.Director.getInstance().getWinSize()
        let systemInfo = mini.getSystemInfoSync()
        let screenHeight = systemInfo.screenHeight
        let screenWidth = systemInfo.screenWidth
        // 最高的位置
        let minY = (1 - (innerBgPos.y + innerSize.height) / wSize.height) * screenHeight
        // 最低的位置
        let maxY = (1 - innerBgPos.y / wSize.height) * screenHeight

        let minX = innerBgPos.x / wSize.width * screenWidth
        let maxX = (innerBgPos.x + innerSize.width) / wSize.width * screenWidth

        OpenContextUtil.postMessage({
            command: "set touch",
            minX: minX,
            minY: minY,
            maxX: maxX,
            maxY: maxY
        })
    } else {
        //  当前平台不支持该功能
        //  TODO:   显示提示语
    }
}

/**
 * 刷新画布
 */
FriendRankMergeList.prototype.refreshCanvas = function () {
    let self = this
    if (self.isClosed || !window.mini || !mini.supportOpenContext()) {
        return
    }

    if (!self.rankSprite) {
        self.rankSprite = cc.Sprite.create()
        self.rankSprite.setContentSize(self.innerBgSize)
        self.rankSprite.setAnchorPoint(0, 0)
        self.rankSprite.setScale(cc.director.getContentScaleFactor())
        self.clippingNode.addChild(self.rankSprite)
    }

    let texture = self.rankSprite.getTexture()
    if (!texture) {
        texture = new cc.Texture2D()
        self.rankSprite.setTexture(texture)
        texture.initWithElement(mini.getOpenDataContext().canvas)
        texture.handleLoadedTexture()
        let rect = cc.rect(0, 0, texture.width, texture.height)
        self.rankSprite.setTextureRect(rect, false)
    } else {
        texture.updateTexture()
    }
}

/**
 * 向开放域发送消息
 */
FriendRankMergeList.prototype.postMessage = function () {
    let self = this

    let rankInfo = {
        levelId : self.config.levelId,
        friendInfo : []
    }
    let textInfo = {
        noRank : getText("rank.list.no.rank"),
        noNetwork : getText("rank.list.no.network")
    }
    for (var i = 0; i < self.itemLength; i++) {
        let data = self.itemdatas[(i+1)]
        
        //  如果头像地址不属于开放域CDN则下载到本地并发送给开放域
        if (!(data.profile.headUrl.indexOf(".qlogo.cn") >= 0)) {
            let param = {
                url: data.profile.headUrl,
                success: res => {
                    OpenContextUtil.postMessage({
                        command: "update img",
                        name: data.profile.uid.toString() + "_picture",
                        path: res.tempFilePath
                    })
                }
            }
            if (mini.useStrictImgMode()) {
                param.extractmap = {
                    picurl: param.url,
                    node: 'FriendRankMergeList.postMessage'
                }
            }
            mini.downloadFile(param)
            data.isLocalPicture = true
        }

        //  添加数据
        if (window.mini && mini.getPlatform() == MiniPlatform.tt){
            rankInfo.friendInfo.push({
                uid: data.profile.uid,
                name: HeDisplayUtil.urlDecode(data.profile.name),
                score: data.score.score,
                headUrl: data.profile.headUrl,
                headFrameId: data.user.headFrameId,
                isLocalPicture: data.isLocalPicture || false
            })
        }else{
            rankInfo.friendInfo.push({
                uid: data.profile.uid,
                name: data.profile.name,
                score: data.score.score,
                headUrl: data.profile.headUrl,
                headFrameId: data.user.headFrameId,
                isLocalPicture: data.isLocalPicture || false
            })
        }
    }

    OpenContextUtil.postMessage({
        command: "level rank",
        openid: META.user.openid,
        shareTicket: self.shareTicket,
        rankInfo: JSON.stringify(rankInfo),
        textInfo: JSON.stringify(textInfo),
        updateScore: self.config.updateScore || 0
    })
}

/**
 * 刷新好友排行信息
 * @param successCallback
 * @param failCallback
 */
FriendRankMergeList.prototype.refresh = function (successCallback, failCallback) {
    var self = this
    if (!window.mini || !mini.supportOpenContext())
        return
    if (self.config.dataLoaded) { // 好友排行只取一次
        return 
    }
    self.config.dataLoaded = true
    if (self.loading) {
        return 
    }
    self.loading = true
    function onSuccess(list) {
        if (!self.nodeExist) {
            return 
        }
        if ($len(list) <= 0) {
            self.itemLength = 0
        } else {
            for (var i = 1, v = list[1]; v; i++, v = list[i]) {
                v.user = FriendManager.getInstance().getFriendInfo(v.score.uid)[0]
                v.user = v.user || UserRef.create()
                table.insert(self.itemdatas, v)
            }
            self.itemLength = $len(self.itemdatas)
        }
        self.loading = false
        self.postMessage()
        if (successCallback) {
            successCallback()
        }
    }
    function onFail(event) {
        if (!self.nodeExist) {
            return 
        }
        self.loading = false
        self.postMessage()
        if (failCallback) {
            failCallback()
        }
    }
    UserRank.getInstance().getFriendRank(self.config.levelId, onSuccess, onFail)
}

FriendRankMergeList.prototype.cleanup = function () {
    var self = this
    //  清理开放域画布
    if (global.mini && mini.supportOpenContext()) {
        OpenContextUtil.postMessage({
            command: "exit"
        })
    }
    if (self.refreshTimer != null) {
        self.getScheduler().unscheduleScriptEntry(self.refreshTimer)
        self.refreshTimer = null;
    }
    BasePanel.prototype.cleanup.call(self)
}
module.exports = FriendRankMergeList